import { useModal } from 'src/app/shared/hooks/useModal';
import { AI_IMAGE_GENERATOR_MODAL_NAME } from 'src/app/shared/components/modals/aiImageGenerator/const';
import { AiImageGeneratorModalProps } from 'src/app/shared/components/modals/aiImageGenerator/model';

export const useAiImageGeneratorModal = () => {
  const { openModal } = useModal();

  const openAiImageGeneratorModal = (props: AiImageGeneratorModalProps) => {
    openModal(AI_IMAGE_GENERATOR_MODAL_NAME, props);
  };

  return {
    openAiImageGeneratorModal,
  };
};
